import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import { Paragraph } from '@uncinc/react-drupal-core';

import { Button, Hero } from '../../../components';
import useScrollToElement from '../../../hooks/useScrollToElement';

import './style.scss';

const NodeFrontPage = ({ entity, className }) => {
  const { t } = useTranslation();

  const { scrollRef, scrollToElement } = useScrollToElement({ block: 'start', inline: 'nearest' });

  const classes = classNames(className, 'FrontPage');

  const type = entity.getIn(['type', 0, 'target_id'], '');
  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');
  const imageField = entity.getIn(['field_media_item', 0], Immutable.Map());

  return (
    <article className={classes} itemScope itemType="https://schema.org/WebPage">
      <Hero
        title={title}
        heroRef={scrollRef}
        body={body}
        imageField={imageField}
        noBackground
        type={type}
        button={(
          <Button onClick={scrollToElement} iconDown>
            {t('buttons.readMore')}
          </Button>
        )}
      />
      {entity.get('field_paragraphs') ? (
        <div className="FrontPage__paragraphs" ref={scrollRef}>
          {entity.get('field_paragraphs', Immutable.List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <Paragraph
                key={`paragraph:${id}:${language}`}
                id={id}
                entity={paragraph.get('entity')}
              />
            );
          })}
        </div>
      ) : null}
    </article>
  );
};

export default NodeFrontPage;
